import type {WhatsNewNote} from '@/api/whatsNew';

// The What's new page's grouping and "seen" state. The notes themselves come from the API
// (useWhatsNew), which serves only this deployment's platform's, so everything here takes them as
// an argument.

export const WHATS_NEW_PATH = '/whats-new';

export const SEEN_KEY = 'pri.whatsNew.seen';

// Newest first; notes sharing a date keep a stable order by id.
export function sortWhatsNew(list: readonly WhatsNewNote[]): WhatsNewNote[] {
  return [...list].sort((a, b) => b.date.localeCompare(a.date) || a.id.localeCompare(b.id));
}

export function markWhatsNewSeen(list: readonly WhatsNewNote[]): void {
  try {
    localStorage.setItem(SEEN_KEY, JSON.stringify(list.map((note) => note.id)));
  } catch {
    // Storage blocked: the dot just comes back next visit.
  }
}

// The ids of these notes that this browser hasn't seen. Storage blocked: none, so nothing is marked
// rather than everything forever.
export function unseenWhatsNew(list: readonly WhatsNewNote[]): Set<string> {
  try {
    const seen = new Set<unknown>(JSON.parse(localStorage.getItem(SEEN_KEY) ?? '[]') as unknown[]);
    return new Set(list.filter((note) => !seen.has(note.id)).map((note) => note.id));
  } catch {
    return new Set();
  }
}

// Whether the sidebar should mark What's new: there's a note this browser hasn't seen. Never while
// on the page itself, which marks everything seen as it opens.
export function hasUnseenWhatsNew(pathname: string, list: readonly WhatsNewNote[]): boolean {
  return pathname !== WHATS_NEW_PATH && unseenWhatsNew(list).size > 0;
}
